export const EDIT_RENEWAL_SUBSCRIPTION_STATUS_MODAL_NAME =
  'EDIT_RENEWAL_SUBSCRIPTION_STATUS_MODAL_NAME';
